module.exports = __webpack_public_path__ + "img/logo.5d8664b4.png";